import React, { Component } from 'react';
import { Header } from '../../organisms';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The landing page floating header.
 *
 * @typedef {Object} Props
 * @prop {boolean} opaque
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class HeaderView extends Component {

	state = {
		navItems: this.genNavItems(this.props.content.landingPage.navigation.items),
	};

	/**
	 * @argument {Object[]} items
	 * @returns {Object[]}
	 */
	genNavItems (items) {
		return items.map(({ href, name }) => ({
			children: name,
			href,
		}));
	}

	render () {
		return (
			<Header
				className='HeaderView'
				navItems={this.state.navItems}
				opaque={this.props.opaque}
			/>
		);
	}

}

export default withLanguageContext(HeaderView);



// WEBPACK FOOTER //
// ./src/components/views/HeaderView/HeaderView.js